import React from 'react';
import { Segment, Table, Header, Icon, Popup } from 'semantic-ui-react';
import { IconHeader } from '../util/css';

/**
    props: switchToTable (function), vehicle (Object)
*/

export default class VehicleDetails extends React.Component {
    render() {
        const { vehicle } = this.props;
        return (
            <div>
                <Header as="h1">Vozila</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            O vozilu
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={this.props.switchToTable} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table celled>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Organizaciona jedinica</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.organizationalUnit.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Tip</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.type ? vehicle.type.name : null}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Proizvođač</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.manufacturer ? vehicle.manufacturer.name : null}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Model</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.model}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Tablice</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.licencePlate}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Godina proizvodnje</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.productionYear}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Godina kupovine</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.purchaseYear}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Broj šasije</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.chassisNumber}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Broj sjedišta</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.numberOfSeats}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Status</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.status ? vehicle.status.name : null}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Tip goriva</b></Table.Cell>
                                    <Table.Cell textAlign="center">{vehicle.fuelType ? vehicle.fuelType.name : null}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/VehicleDetails.js